import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import FilmingTips from "@/pages/FilmingTips";

export const Route = createFileRoute("/filming-tips")({
  head: () => buildRouteHead("/filming-tips"),
  component: FilmingTips,
});

